import React from 'react';
import BrandLogo from './BrandLogo';

/**
 * Welcome / introduction step shown before the first data section.
 * No form data is collected here.
 *
 * @param {string} clientName - Personalises the greeting.
 */
export default function StepWelcome({ clientName }) {
  return (
    <div className="cashflow-welcome">
      <BrandLogo size={72} className="mb-3" />
      <h1 className="h3 fw-bold cashflow-brand-text mb-3">
        Welcome{clientName ? `, ${clientName.split(' ')[0]}` : ''}!
      </h1>

      <p className="lead text-muted mb-4">
        This questionnaire helps your financial advisor understand where your
        money comes from and where it goes — so they can build a plan for your
        future.
      </p>

      <div className="alert alert-light border-start border-4 border-danger mb-4 py-3">
        <h6 className="fw-bold mb-2">
          <i className="bi bi-lightbulb me-2 text-danger" />
          Before you start
        </h6>
        <ul className="mb-0 small text-muted ps-3">
          <li>All dollar amounts should be <strong>annual</strong> (yearly) totals.</li>
          <li>Only include <strong>recurring</strong> expenses — leave out one-time costs.</li>
          <li>Your progress is <strong>saved automatically</strong> when you click Next.</li>
          <li>
            You can return to this page anytime using the same link your advisor
            sent you.
          </li>
          <li>It doesn't have to be perfect — an estimate is fine.</li>
          <li>
            Have bank or credit-card statements, pay stubs, or mortgage, insurance or savings
            statements? You can <strong>upload them on the next page</strong> to pre-fill amounts.
          </li>
        </ul>
      </div>

      <div className="row g-3">
        {[
          { icon: 'bi-cash-coin', label: 'Income', desc: 'Where your money comes from.' },
          { icon: 'bi-house', label: 'Housing & Bills', desc: 'Mortgage, rent, utilities.' },
          { icon: 'bi-heart-pulse', label: 'Medical & Insurance', desc: 'Healthcare and protection.' },
          { icon: 'bi-piggy-bank', label: 'Savings & Debts', desc: 'What you save and owe.' },
        ].map(({ icon, label, desc }) => (
          <div key={label} className="col-6 col-md-3">
            <div className="card border-0 bg-light h-100 text-center p-3">
              <i className={`bi ${icon} fs-3 text-danger mb-2`} />
              <div className="fw-semibold small">{label}</div>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>{desc}</div>
            </div>
          </div>
        ))}
      </div>

      <p className="text-muted small mt-4 mb-0">
        Click <strong>Next</strong> to begin.
      </p>
    </div>
  );
}
